/**
 * Classe base para todos os fields.
 * @author: Adalto Junior
 * Date: 20/09/13
 * Time: 11:47
 */


Monet.UI = Monet.UI || {};
Monet.UI.Fields = Monet.UI.Fields || {};

Monet.UI.Fields.Distance = (function () {

    function Distance() {

        Monet.UI.Fields.TextField.apply (this, arguments);

        //Campos em metros e feets não devem exibir casas decimais
        this.precision = 0;

        this.getValue = function () {

            this.value = '';

            if (this.input && this.input.value) {
                this.value = this.convertToMetricSystem(this.input.value);
            }

            return this.value;
        };

        this.setInputValue = function () {

            if ((this.value || this.value === 0) && this.input) {

                this.input.value = this.convertToUserMetricSystem(this.value);

            }

        };

        this.convertToMetricSystem = function (value) {

            var valueToConvert = value || 0;

            var formatter = new Monet.Format.DISTANCE(valueToConvert);

            formatter.parseFloat();

            if (Monet.Session.User.unitSystem === "NON_METRIC") {

               formatter.convertFeetToMeters();

            }

            return formatter.getValue();

        };

        this.convertToUserMetricSystem = function (value) {

            var valueToConvert = value || 0;

            var formatter = new Monet.Format.DISTANCE(valueToConvert);

            if (Monet.Session.User.unitSystem === "NON_METRIC") {

                formatter.convertMetersToFeet();

            } else if (typeof valueToConvert === 'string') {

                formatter.parseFloat();

            }

            return formatter.setPrecision(this.precision).formatWithoutSeparatorThousands().getValue();

        };

        this.createElement = function () {

            this.input = document.createElement('input');

            this.input.type = 'text';
            this.input.className = 'distanceField';

            if(this.maxSize){
                this.input.maxLength = this.maxSize;
            }

            this.rootEl.appendChild(this.input);

        };

        this.addEventListeners = function () {

            var precision;
            if ( this.meta && this.meta.precision ) {
                precision = this.meta.precision.substr(1);
                this.input.setAttribute('precision', precision);
                this.precision = precision;
            }

            $(this.input).on("keyup blur focus", function (e) {
                e.preventDefault();

                var expre = /[^0-9,.]/g;

                if ($(this).val().match(expre)) {
                    $(this).val($(this).val().replace(expre, ''));
                }
            });

        };

        this.render = function () {

            this.createElement();
            this.addEventListeners();
            this.setInputValue();
            return this.rootEl;

        };

    }

    return Distance;

}());